import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { ILocationResponse, ILocationState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchShowLocation = createAsyncThunk(
  'listLocations/fetchShowLocation',
  async (id: string, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.location(id)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: ILocationState = {
  isLoading: false,
  response: null,
  error: null
}

const showLocationSlice = createSlice({
  name: 'locations/show',
  initialState,
  reducers: {
    resetShowLocation: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchShowLocation.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchShowLocation.fulfilled, (state, action: PayloadAction<ILocationResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchShowLocation.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default showLocationSlice.reducer
export const { resetShowLocation } = showLocationSlice.actions
